<div class="body-container">
  <div class="page-main">
    <div class="page-container">
      <div class="form-wrapper">
        <div class="form-content">
          <div *ngIf="isEventReady" class="form-section">
            <div class="form-section-side">
              <h1 class="label-title">Log Detail</h1>
            </div>
            <div class="form-section-container">
              <div class="form-section-body">
                <div class="form-row row-data-detail">
                  <label class="typo label fw300 semi-condensed italic">Event Id</label>
                  <label class="typo body-1 fw400 semi-condensed"># {{ event?.id }}</label>
                </div>
                <div class="form-row row-data-detail">
                  <label class="typo label fw300 semi-condensed italic">Level</label>
                  <label class="typo body-1 fw400 semi-condensed">{{ event?.level }}</label>
                </div>
                <div class="form-row row-data-detail">
                  <label class="typo label fw300 semi-condensed italic">Message</label>
                  <label class="typo body-1 fw400 semi-condensed">{{ event?.message }}</label>
                </div>
                <div class="form-row row-data-detail">
                  <label class="typo label fw300 semi-condensed italic">Name</label>
                  <label class="typo body-1 fw400 semi-condensed">{{ event?.name }}</label>
                </div>
                <div class="form-row row-data-detail">
                  <label class="typo label fw300 semi-condensed italic">Source</label>
                  <label class="typo body-1 fw400 semi-condensed">{{ event?.source }}</label>
                </div>
                <div class="form-row row-data-detail">
                  <label class="typo label fw300 semi-condensed italic">Created At</label>
                  <label class="typo body-1 fw400 semi-condensed">{{ event?.createdAt }}</label>
                </div>
                <div class="form-row row-data-detail">
                  <label class="typo label fw300 semi-condensed italic">Updated At</label>
                  <label class="typo body-1 fw400 semi-condensed">{{ event?.updatedAt }}</label>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!isEventReady">
            <skeleton-loader-form [insideSection]=true [numberOfInputs]=8></skeleton-loader-form>
          </div>
          <div *ngIf="isEventReady" class="form-section">
            <div class="form-section-side">
              <h1 class="label-title">User</h1>
            </div>
            <div class="form-section-container">
              <div class="form-section-body">
                <div class="form-row row-data-detail">
                  <label class="typo label fw300 semi-condensed italic">User Id</label>
                  <label class="typo body-1 fw400 semi-condensed"># {{ event?.user?.id }}</label>
                </div>
                <div class="form-row row-data-detail">
                  <label class="typo label fw300 semi-condensed italic">User</label>
                  <label class="typo body-1 fw400 semi-condensed">{{ event?.user?.firstName }} {{ event?.user?.lastName }}</label>
                </div>
                <div class="form-row row-data-detail">
                  <label class="typo label fw300 semi-condensed italic">Username.</label>
                  <label class="typo body-1 fw400 semi-condensed">{{ event?.user?.username }}</label>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!isEventReady">
            <skeleton-loader-form [insideSection]=true [numberOfInputs]=5></skeleton-loader-form>
          </div>
          <div *ngIf="isEventReady" class="form-section">
            <div class="form-section-side">
              <h1 class="label-title">Full Content</h1>
            </div>
            <div class="form-section-container">
              <div class="form-section-body">
                <div class="form-row row-data-json">
                  <div contenteditable="false" class="json-code-block">
                    {{event?.jsonContent | json}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!isEventReady">
            <skeleton-loader-form [insideSection]=true [numberOfInputs]=5></skeleton-loader-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
